import React, { memo } from 'react'
import { Stack } from '@mui/material'

import Text from '../shared/text/Text'
import banner from '../../assets/images/qbx-landing.png'

const QBXBanner = ({ t, children }) => {
  const steps = [
    t('home.connect-your-wallet'),
    t('home.deposit-for-allocation'),
    t('home.more-tickets')
  ]
  return (
    <Stack sx={{ alignItems: 'center', justifyContent: 'center' }} spacing={0}>
      <Text
        label={t('home.enter-the-ultimate-rewards')}
        fontWeight={700}
        textAlign='center'
        sx={{ mb: 2 }}
      />
      <Stack>
        {steps.map((step, index) => (
          <Text
            key={index}
            variant='h6'
            label={`${index + 1}. ${step}`}
            fontWeight={500}
            color='text.secondary'
            textAlign='center'
          />
        ))}
      </Stack>
      <img src={banner} style={{ height: 340 }} />
      <Text
        label={
          <>
            Up to{' '}
            <Text
              label='$1.25m'
              color='primary.main'
              component='span'
              fontWeight={700}
            />{' '}
            rewards pool!
          </>
        }
        fontWeight={700}
        textAlign='center'
        sx={{ mb: 2 }}
      />
      {children}
    </Stack>
  )
}

export default memo(QBXBanner)
